import React from 'react';
import { Redirect } from 'react-router-dom';

import Spinner from 'components/atoms/spinner';
import { LicensedModule } from 'hocs/accessibleByLicense/typing';
import { useLicensing } from 'hocs/accessibleByLicense/useLicensing';

const accessibleByLicense =
  (redirectPath: string) =>
  (requiredLicense: LicensedModule) =>
  (Component: React.ComponentType) =>
  () => {
    const { hasLicense, isLoading } = useLicensing();

    if (isLoading) {
      return <Spinner />;
    }

    if (hasLicense(requiredLicense)) {
      return <Component />;
    }

    return <Redirect to={redirectPath} />;
  };

export default accessibleByLicense;
